<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>
        </div>

        <div class="container md:flex">
            <div class="w-full md:w-3/4">
                <article class="bg-white border-t-8 border-green-700 p-4">
                    <h1 v-if="model.heading || isEditable" v-epi-edit="'Heading'" class="text-gray-900 font-bold text-3xl mb-8">
                        {{ model.heading }}
                   </h1>

                    <img
                        v-if="model.image"
                        v-epi-edit="'Image'"
                        :src="`${model.image}?scale=both&width=1120&mode=crop&anchor=middlecenter`"
                        :alt="model.heading"
                        :title="model.heading"
                        class="w-full h-auto mb-4 mx-auto"
                    />

                    <ul class="flex border-b border-t border-gray-400 py-2">
                        <li class="p-1">
                            <div v-if="isEditable" class="block">
                                <EpiProperty propertyName="EventStartDate" displayText="Start dato"/>
                                <EpiProperty propertyName="EventStopDate" displayText="Slutt dato" />
                            </div>
                            <font-awesome-icon class="mr-1 text-green-600" icon="clock" />
                            <span v-html="date()"></span>
                        </li>
                        <li v-if="model.sted || isEditable" class="p-1">
                           <div v-if="isEditable" class="block">
                                <EpiProperty propertyName="Sted" />
                            </div>
                            <font-awesome-icon class="mr-1 text-green-600" icon="map-marker-alt" />
                            Sted: {{ model.sted }}
                        </li>
                    </ul>

                    <p v-if="model.arrangedBy || isEditable" v-epi-edit="'ArrangedBy'" class="py-3 px-1 border-b border-gray-400 mb-4">
                        <font-awesome-icon class="mr-1 text-green-600" icon="chalkboard-teacher" />
                        Arrangør: {{ model.arrangedBy }}
                    </p>

                    <div v-if="model.mainBody || isEditable" v-html="model.mainBody" v-epi-edit="'MainBody'" class="article"></div>

                    <p v-if="model.eventLink || isEditable" v-epi-edit="'EventLink'" class="text-center my-8">
                        <a :href="model.eventLink" title="Mer info og påmelding (åpnes i eget vindu)" target="_blank" class="btn btn-green rounded-none inline-block py-2 px-4">
                            Mer info og påmelding &#10095;
                        </a>
                    </p>
                </article>
            </div>

            <div class="w-full md:w-1/4 p-0 md:pl-4">
                <a
                    v-epi-edit="'ParentLink'"
                    :href="model.parentLink.url"
                    title="Gå til vår kurskalender"
                    class="btn btn-green rounded-none block py-2 px-4 mb-4"
                >
                    <font-awesome-icon class="mr-1" icon="calendar-alt" />
                    Kurskalender &#10095;
                </a>

                <ol v-if="model.nextCourses" class="">
                    <template v-for="(course, index) in courses">
                        <course-list-element :course="course" :key="index" :classes="'w-full'" />
                    </template>
                </ol>

            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import { mapState } from 'vuex';
import EpiProperty from '@/Scripts/components/EpiProperty.vue';
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import CourseListElement from '@/Scripts/components/organisms/CourseListElement/courseListElement.vue';

export default {
    props: ['model'],
    components: {
        EpiProperty,
        Breadcrumbs,
        CourseListElement
    },
    data() {
        return {
            start: this.model.eventStartDate,
            end: this.model.eventStopDate,
            courses: this.model.nextCourses
        };
    },
    computed: mapState({
        isEditable: state => state.epiContext.isEditable
    }),
    methods: {
        date() {
            const months = ['januar','februar','mars','april','mai','juni','juli','august','september','oktober','nobember','desember'];
            if (this.start === this.end) {
                const d = new Date(this.start);
                const date = ('0' + d.getDate()).slice(-2);
                const month = months[d.getMonth()];
                const year = d.getFullYear();
                return date + '. ' + month + ' ' + year;
            }

            if (this.start !== this.end) {
                const dStart = new Date(this.start);
                const dEnd = new Date(this.end);

                const dateStart = ('0' + dStart.getDate()).slice(-2);
                const monthStart = months[dStart.getMonth()];
                const yearStart = dStart.getFullYear();

                const dateEnd = ('0' + dEnd.getDate()).slice(-2);
                const monthEnd = months[dEnd.getMonth()];
                const yearEnd = dEnd.getFullYear();

                const date = dateStart + '.&rarr;' + dateEnd;

                let year = yearStart;
                if (yearStart !== yearEnd) {
                    year = yearStart + '&rarr;' + yearEnd;
                }

                const month = monthStart;
                if (monthStart !== monthEnd) {
                    return dateStart + '. ' + monthStart + ' &rarr; ' + dateEnd + '. ' + monthEnd + ' ' + year;
                }

                return date + '. ' + month + ' ' + year;
            }
        }
    }
};
</script>
